var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProducts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2 21.6A1.6 1.6 0 0 1 9.6 20v-5.6a1.6 1.6 0 0 1 1.6-1.6H20a1.6 1.6 0 0 1 1.6 1.6V20c0 .884-.715 1.6-1.6 1.6h-8.8zm0-1.6H20v-5.6h-8.8V20zm-7.198 1.6A1.6 1.6 0 0 1 2.4 20v-5.6c0-.883.717-1.6 1.602-1.6h2.4A1.6 1.6 0 0 1 8 14.4V20a1.6 1.6 0 0 1-1.6 1.6h-2.4zm0-1.6h2.4v-5.6h-2.4V20zM17.6 11.2a1.6 1.6 0 0 1-1.6-1.6V4.002a1.6 1.6 0 0 1 1.6-1.602h2.4a1.6 1.6 0 0 1 1.6 1.602V9.6c0 .885-.716 1.6-1.6 1.6h-2.4zm0-1.6h2.4V4.002h-2.4V9.6zm-13.6 1.6A1.6 1.6 0 0 1 2.4 9.6V4.002c0-.885.717-1.602 1.602-1.602H12.8a1.6 1.6 0 0 1 1.6 1.602V9.6c0 .885-.715 1.6-1.6 1.6H4.002zm0-1.6h8.8V4.002H4V9.6z",
    fill: "#161338"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts);
export default __webpack_public_path__ + "static/media/products.879ebe144d8686ea91dc82f2f6733759.svg";
export { ForwardRef as ReactComponent };